import React from 'react';
import { Redirect } from 'react-router-dom';
import { auth } from '../firebase';
const withAuth = (Component) => {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                status: 'LOADING',
            }
        }
        componentDidMount() {
            auth.onAuthStateChanged(authUser => {
                if(authUser) {
                    this.setState({
                        status: 'SIGNED_IN'
                    });
                } else {
                    this.setState({
                        status: 'REDIRECT'
                    })
                }
            });
        }
        renderContent() {
            const { status } = this.state;
            if(status == 'LOADING') {
                return (
                    <div className="loading">
                        <div className="d-table">
                            <div className="d-table-cell">
                                <h1>Cargando...</h1>
                            </div>
                        </div>
                    </div>
                );
            } else if (status == 'SIGNED_IN') {
                return <Component { ...this.props } />
            } else if (status== "REDIRECT") {
                return <Redirect to= '/admin/login' />
            }
        }
        render() {
            return (
                <React.Fragment>
                    {this.renderContent()}
                </React.Fragment>
            );
        }
    };
}
export default withAuth;